export enum ResourceIcon {
  Unknown = '/icons/App.svg',
  TextDocument = '/icons/Word.svg',
  PdfDocument = '/icons/Pdf.svg',
  WordDocument = '/icons/Word.svg',
  Video = '/icons/Video.svg',
  Audio = '/icons/Video.svg',
  Images = '/icons/Image.svg',
  WebPage = '/icons/Web.svg',
  YoutubeVideos = '/icons/Youtube.svg',
  VimeoVideos = '/icons/Vimeo.svg',
  Spreadsheet = '/icons/Excel.svg',
  Presentation = '/icons/Powerpoint.svg',
  HTML5 = '/icons/App.svg',
  PhotoAlbum = '/icons/Image Gallery.svg',
  KeyNote = '/icons/Image Gallery.svg',
  Slides = '/icons/Powerpoint.svg',
  PptVar = '/icons/Powerpoint.svg',
  PdfSinglePage = '/icons/Pdf.svg',
  JSON = '/icons/Word.svg',
  CSV = '/icons/Excel.svg',
  App = '/icons/App.svg',
  Powerpoint = '/icons/Powerpoint.svg'
}
